import { Button, Grid } from "@mui/material";
import { UseFormReturn } from "react-hook-form";

import {
  gridSizeMdLg12,
  gridSizeMdLg6,
  texto,
} from "@/shared";
import {
  CustomAutocompleteArrString,
  CustomTextArea,
  CustomTextField,
  CustomTextFieldNoForm,
  CustomTextFieldNumberComponente,
  SampleCheckbox,
  SampleDatePicker,
  TabTextLabel,
} from "@/shared/components/ui";
import { IPreventaCorporativoForm2 } from "@/shared/interfaces/erp/preventa/preventa_corporativo.interface";
// import { useUploadImageComponent } from "@/erp/tecnico/orden-trabajo/shared/hooks";
// import { Dispatch, SetStateAction } from "react";
import { TiposTextFieldNumberEnum } from "@/shared/components/ui/CustomTextFieldNumberComponente";
import { CondicionVentaCorporativa } from "@/shared/interfaces/erp/prospecto/prospecto_corporativo.interface";
import dayjs from "dayjs";
// import FormCoordendas from "../form_coordenadas/form_coordendas";

const TIPOS_DE_ENLACE = [
  "PRINCIPAL",
  "BACK UP FO 2H",
  "PRINCIPAL RADIO FRECUENCIA",
  "BACKUP RADIO FRECUENCIA",
];
interface TabDatosGeneralesCorporativoProps {
  form: UseFormReturn<IPreventaCorporativoForm2, any, IPreventaCorporativoForm2>;
  enableEdit?: boolean;
  valorRestriccionCel?: any
  // fotoCedCorporativoFrontal: File | null;
  // setFotoCedCorporativoFrontal: Dispatch<SetStateAction<File | null>>;
  // fotoCedCorporativoPosterior: File | null;
  // setFotoCedCorporativoPosterior: Dispatch<SetStateAction<File | null>>;
  // fotoCorporativoRUC: File | null;
  // setFotoCorporativoRUC: Dispatch<SetStateAction<File | null>>;
}
export default function TabDatosGeneralesCorporativo({
  form,
  valorRestriccionCel
}: 
TabDatosGeneralesCorporativoProps) {
  // const [test, settest] = useState(false);
  ///* STATES ------------
  const {
    // reset,
    control,
    formState: { errors },
  } = form;


  // const {
  //   UploadImageComponent,
  // } = useUploadImageComponent();

  return (
    <Grid container {...gridSizeMdLg12} width={"100%"} spacing={2}>
      <Grid {...gridSizeMdLg6} item container columnSpacing={0} rowSpacing={3} >
        <CustomTextFieldNoForm
          required={false}
          disabled={true}
          label={"Razon Social"}
          defaultValue={form.getValues().razon_social}
          value={
            form.getValues().razon_social ||
            form.getValues()?.prospecto_corporativo_data?.razon_social ||
            ""
          }
          shrink={
            !!form.getValues().razon_social ||
            !!form.getValues()?.prospecto_corporativo_data?.razon_social
          }
          size={gridSizeMdLg12}
        />
        <CustomTextFieldNoForm
          required={false}
          disabled={true}
          defaultValue={
            form.getValues().nombre_comercial ||
            form.getValues()?.prospecto_corporativo_data?.nombre_comercial ||
            "N/A"
          }
          size={gridSizeMdLg12}
          label={"Nombre Comercial"}
          shrink={
            !!form.getValues().nombre_comercial ||
            !!form.getValues()?.prospecto_corporativo_data?.nombre_comercial
          }
          // error={errors.nombre_comercial}
          // helperText={errors.nombre_comercial?.message}
          // control={control}
          // name="nombre_comercial"
        />
        <CustomTextFieldNoForm
          required={false}
          disabled={true}
          label={"RUC"}
          defaultValue={form.getValues().identificacion}
          value={form.getValues().identificacion}
          shrink={!!form.getValues().identificacion}
          size={gridSizeMdLg12}
        />
        <CustomTextFieldNumberComponente
          size={gridSizeMdLg12}
          type={TiposTextFieldNumberEnum.CELULAR}
          label={texto.celular}
          error={errors.celular}
          helperText={errors.celular?.message}
          control={control}
          name="celular"
          required={false}
          defaultValue={
            form.getValues().celular ||
            form.getValues()?.prospecto_corporativo_data?.celular ||
            ""
          }
          customRestriccionCelular={valorRestriccionCel}
        />
        <CustomTextFieldNumberComponente
          size={gridSizeMdLg12}
          type={TiposTextFieldNumberEnum.CELULAR}
          label={`${texto.celular} 2`}
          error={errors.celular_2}
          helperText={errors.celular_2?.message}
          control={control}
          name="celular_2"
          required={false}
          defaultValue={form.getValues().celular_2 || ""}
          customRestriccionCelular={valorRestriccionCel}
        />
      </Grid>

      <Grid {...gridSizeMdLg6} item container columnSpacing={0} rowSpacing={3}>
        <CustomTextField
          control={control}
          type="email"
          name="email"
          defaultValue={
            form.getValues().email ||
            form.getValues()?.prospecto_corporativo_data?.email ||
            ""
          }
          size={gridSizeMdLg12}
          label={texto.email}
          error={errors.email}
          onChangeValue={(val) =>
            form.reset({ ...form.getValues(), email: val })
          }
          helperText={errors.email?.message}
          required={false}
        />
        <CustomTextField
          control={control}
          name="persona_contacto"
          defaultValue={
            form.getValues().persona_contacto ||
            form.getValues()?.prospecto_corporativo_data?.persona_contacto ||
            ""
          }
          size={gridSizeMdLg12}
          label={"Persona de Contacto"}
          error={errors.persona_contacto}
          helperText={errors.persona_contacto?.message}
          required={false}
        />
        <CustomTextField
          control={control}
          name="direccion"
          defaultValue={
            form.getValues().direccion ||
            form.getValues()?.prospecto_corporativo_data?.direccion ||
            ""
          }
          size={gridSizeMdLg12}
          label={texto.direccion}
          error={errors.direccion}
          helperText={errors.direccion?.message}
          required={false}
        />
        <CustomTextField
          control={control}
          name="tecnico_responsable"
          defaultValue={form.getValues().tecnico_responsable}
          size={gridSizeMdLg12}
          label={"Técnico Responsable del Cliente"}
          error={errors.tecnico_responsable}
          helperText={errors.tecnico_responsable?.message}
          required={false}
        />

        <CustomTextField
          control={control}
          name="email_tecnico_responsable"
          type="email"
          defaultValue={form.getValues().email_tecnico_responsable}
          size={gridSizeMdLg12}
          label={"Email Técnico Responsable del Cliente"}
          error={errors.email_tecnico_responsable}
          helperText={errors.email_tecnico_responsable?.message}
          required={false}
        />
        
      </Grid>

      <Grid item {...gridSizeMdLg12}>
        <CustomTextArea
          size={gridSizeMdLg12}
          label={"Observación Vendedor"}
          name="observacion_vendedor"
          control={control}
          defaultValue={
            form.getValues().observacion_vendedor ||
            form.getValues()?.prospecto_corporativo_data?.observaciones
              ?.observacion_vendedor ||
            ""
          }
          error={errors.observacion_vendedor}
          helperText={errors.observacion_vendedor?.message}
          required={false}
          autoGrow
          maxRows={14}
        />
      </Grid>
      {/* <Grid item   {...gridSizeMdLg12}>
        <CustomTextAreaNoForm
          size={gridSizeMdLg12}
          label={"Observación Prefactibilidad"}
          value={form.getValues()?.observaciones?.observacion_prefactibilidad || form.getValues()?.observacion_prefactibilidad ||"N/A"}
          disabled
        />
      </Grid> */}
      {form.getValues()?.observaciones?.file_observacion_prefactibilidad ? (
        <>
          <Grid item>
            <a
              target="_blank"
              href={
                `${
                  form.getValues()?.observaciones
                    ?.file_observacion_prefactibilidad
                }?${new Date().getTime()}` || "#"
              }
            >
              {/* <a target="_blank" href={`${dataFactibilidadCorporativa?.observaciones?.file_observacion_inspeccion_factibilidad}?${(new Date().getTime())}`||"#"}> */}
              <Button variant="outlined">Ver/Descargar Anexo</Button>
            </a>
          </Grid>
        </>
      ) : null}

      {form.getValues().condicion_venta ==
        CondicionVentaCorporativa.EVENTO_GRATUITO ||
      form.getValues().condicion_venta ==
        CondicionVentaCorporativa.EVENTO_PAGADO ? (
        <Grid
          item
          container
          spacing={2}
          justifyContent={"start"}
          alignContent={"start"}
          {...gridSizeMdLg12}
        >
          <Grid {...gridSizeMdLg12} mt={2}>
            <TabTextLabel text="Detalles del Cliente " />
          </Grid>
          {/* <CustomTextField
              control={control}
              type="date"
              name="fecha_inicio_evento"
              shrink={true}
              defaultValue={formatDate(form.getValues().fecha_inicio_evento!)  || ''}
              size={gridSizeMdLg6}
              label={"FECHA INICIO EVENTO"}
              error={errors.fecha_inicio_evento}
              helperText={errors.fecha_inicio_evento?.message} /> */}

          <SampleDatePicker
            label="Fecha Inicio de Evento"
            name="fecha_inicio_evento"
            control={form.control}
            defaultValue={dayjs().format() || null}
            error={form.formState.errors.fecha_inicio_evento}
            helperText={form.formState.errors.fecha_inicio_evento?.message}
            minDate={dayjs()}
            size={gridSizeMdLg6}
          />
          <SampleDatePicker
            label="Fecha Fin de Evento"
            name="fecha_fin_evento"
            control={form.control}
            defaultValue={dayjs().format() || null}
            error={form.formState.errors.fecha_fin_evento}
            helperText={form.formState.errors.fecha_fin_evento?.message}
            minDate={dayjs()}
            size={gridSizeMdLg6}
          />
          {/* <CustomTextField
              control={control}
              shrink={true}
              type="date"
              name="fecha_fin_evento"
              defaultValue={form.getValues().fecha_fin_evento?.toString() || ''}
              size={gridSizeMdLg6}
              label={"FECHA FIN EVENTO"}
              error={errors.fecha_fin_evento}
              helperText={errors.fecha_fin_evento?.message} />*/}
        </Grid>
      ) : null}

      <Grid
        item
        container
        spacing={2}
        justifyContent={"start"}
        alignContent={"start"}
        {...gridSizeMdLg12}
      >
        <Grid {...gridSizeMdLg12} mt={2}>
          <TabTextLabel text="Detalles del Cliente " />
        </Grid>
        

        <CustomTextField
          control={control}
          name="ejecutivo_comercial"
          defaultValue={form.getValues().ejecutivo_comercial}
          size={gridSizeMdLg6}
          label={"Ejecutivo Comercial"}
          error={errors.ejecutivo_comercial}
          helperText={errors.ejecutivo_comercial?.message}
          disabled={true}
          required={false}
        />

        <Grid item container {...gridSizeMdLg6} spacing={3}>
          <SampleCheckbox
            size={gridSizeMdLg6}
            label="¿Tiene CDNs?"
            control={form.control}
            name="tiene_cdns"
            defaultValue={form.getValues().tiene_cdns || false}
            onChangeValue={(e) => {
              form.reset({ ...form.getValues(), tiene_cdns: e });
            }}
          />
          {form.watch().tiene_cdns && (
            <CustomTextField
              control={control}
              name="cdns_detalle"
              defaultValue={form.getValues().cdns_detalle}
              size={gridSizeMdLg6}
              label={"Detalle de CDNs"}
              error={errors.cdns_detalle}
              helperText={errors.cdns_detalle?.message}
            />
          )}
        </Grid>
      </Grid>

      {/* <Grid
        item
        container
        spacing={2}
        justifyContent={"start"}
        alignContent={"start"}
        {...gridSizeMdLg12}
      >
        <CustomCoordendasForm
          form={form}
          label="Coordendas de Fusión"
          name="coordenada_fusion"
          defaultValue={form.watch().coordenada_fusion}
          key={"key_coordenada_fusion"}
          size={gridSizeMdLg6}
          onlyValueLocation={true}
          disabled={
            form.getValues()?.estado_preventa == EstadoPreventaEnum.EN_PROCESO
              ? true
              : false
          }
          required={false}
        />

        <CustomTextField
          control={control}
          name="direccion_fusion"
          defaultValue={form.getValues().direccion_fusion}
          size={gridSizeMdLg6}
          label={"Dirección de Fusión"}
          error={errors.direccion_fusion}
          helperText={errors.direccion_fusion?.message}
          required={false}
        /> */}

        {/*         
        <FormCoordendas
          form={form}
          label="Coordendas Empresa"
          name="coordenada_empresa"
          defaultValue={form.watch().coordenada_empresa}
          key={'key_coordenada_empresa'}
          size={gridSizeMdLg6}
          onlyValueLocation={true}
        />

        <CustomTextField
          control={control}
          name="direccion_empresa"
          defaultValue={form.getValues().direccion_empresa}
          size={gridSizeMdLg6}
          label={'Dirección Empresa'}
          error={errors.direccion_empresa}
          helperText={errors.direccion_empresa?.message}
        />

        

        <FormCoordendas
          form={form}
          label="Coordendas Servicio"
          name="coordenada_servicio"
          defaultValue={form.watch().coordenada_servicio}
          key={'key_coordenada_servicio'}
          size={gridSizeMdLg6}
          // autoLocation={true}
          enableLocationOnChange={true}
        />

        <CustomTextField
          control={control}
          name="direccion_servicio"
          defaultValue={form.getValues().direccion_servicio}
          size={gridSizeMdLg6}
          label={'Dirección Servicio'}
          error={errors.direccion_servicio}
          helperText={errors.direccion_servicio?.message}
        /> */}
      {/* </Grid> */}

      <Grid
        item
        container
        spacing={2}
        justifyContent={"start"}
        alignContent={"start"}
        {...gridSizeMdLg12}
      >
        <CustomAutocompleteArrString
          size={gridSizeMdLg6}
          label={"Servicio"}
          name="tipo_servicio"
          // DATOS E INTERNET,  FIBRA OSCURA
          options={["SIN SELECCION", "INTERNET", "DATOS", "FIBRA OSCURA", "DATOS BCO CENTRAL"]}
          defaultValue={form.getValues().tipo_servicio || "SIN SELECCION"}
          isLoadingData={false}
          control={control}
          error={errors.tipo_servicio}
          helperText={errors.tipo_servicio?.message}
          required={true}
        />

        <CustomAutocompleteArrString
          size={gridSizeMdLg6}
          label={"Enlace"}
          name="tipo_enlace"
          options={TIPOS_DE_ENLACE}
          defaultValue={form.getValues().tipo_enlace}
          isLoadingData={false}
          control={control}
          error={errors.tipo_enlace}
          helperText={errors.tipo_enlace?.message}
          required={false}
        />
        {/* <Grid {...gridSizeMdLg12} mt={2}>
          <TabTextLabel text="Fotos del cliente "/>
        </Grid>

        <Grid item {...gridSizeMdLg4}>
          <UploadImageComponent
            buttonText={'Cédula Frontal'}
            selectedImage={fotoCedCorporativoFrontal}
            setSelectedImage={setFotoCedCorporativoFrontal}
            idInput={'entrada-fotoFrontalCorporativo'}
          />
        </Grid>
        <Grid item {...gridSizeMdLg4}>
          <UploadImageComponent
            buttonText={'Cédula Posterior'}
            selectedImage={fotoCedCorporativoPosterior}
            setSelectedImage={setFotoCedCorporativoPosterior}
            idInput={'entrada-fotoPosteriorCorporativo'}
          />
        </Grid>
        <Grid item {...gridSizeMdLg4}>
          <UploadImageComponent
            buttonText={'RUC'}
            selectedImage={fotoCorporativoRUC}
            setSelectedImage={setFotoCorporativoRUC}
            idInput={'entrada-fotoRUCcorporativo'}
          />
        </Grid> */}
      </Grid>
    </Grid>
  );
}
